import React, { useCallback } from 'react';
import { graphql, QueryRenderer } from 'react-relay';
import modernEnvironment from '../../lib/RelayUtils';
import * as BlockedUserMutation from '../../mutations/BlockedUserMutation';
import Stats from './Stats';

const StatsLoader = ({ match, history }) => {
	const userId = match.params.userId;
	const page = parseInt(match.params.page || 1, 10);

	const handleChangePage = useCallback(
		newPage => {
			history.push(`/stats/${userId}/${newPage}`);
		},
		[history, userId],
	);

	const handleBlockedClick = useCallback(() => {
		BlockedUserMutation.commit(modernEnvironment, { userId }, () => {
			history.go(0);
		});
	}, [userId]);

	const handleClick = useCallback(
		selectedUser => {
			history.push(`/stats/${selectedUser._id}`);
		},
		[history],
	);

	return (
		<QueryRenderer
			environment={modernEnvironment}
			query={graphql`
				query StatsLoaderQuery {
					viewer {
						users(first: -1) {
							edges {
								node {
									_id
									id
									email
									name
									canDelete
									blocked
								}
							}
						}
					}
				}
			`}
			render={({ error, props }) => {
				if (error) {
					return <div>{error.message}</div>;
				}

				if (props) {
					return (
						<Stats
							userId={userId}
							page={page}
							users={props.viewer.users.edges}
							handleClick={handleClick}
							handleChangePage={handleChangePage}
							handleBlockedClick={handleBlockedClick}
						/>
					);
				}

				return <div>Loading...</div>;
			}}
		/>
	);
};

export default StatsLoader;



// WEBPACK FOOTER //
// src/components/stats/StatsLoader.js